import Cookies from "cookies-js";
import moment from "moment";	//todo: maybe use something other than moment since it is a dead product
import {allTransferableProducts} from "../configs/app/allTransferableProducts";

function parseJwt(token) {
    if (token === undefined || token === null) return undefined;
    return JSON.parse(window.atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
}

class currentUser {

    constructor() {
        this.cookieAccessToken = "auicsRikahisH9npjhNg4xYVz1aSxnpqxR8LVSN4YS9";
        this.cookieRefreshToken = "auifPK8NofqCnNYDuLDJpBu0kaz8jO3OP8Ne1dbE1SJ";
        this.cookieUserId = "auigqJeGWoGxwvElzq63JTAfi64k20PmUN7Aw7wVyiP";
        this.cookieTokenExpirationDate = "auifEATnZldm97Eku9Bq9I1nxDNSfSKQrdCwHAa1TK9";
        this.cookieCustomerProducts = "auihemd4XMsgYDIPi5jPPJXaL6IUfxysGo2fwv7EArl";
        this.cookieAccessTokenExpirationDate = "auizd3Rd2ZFztzzASxu2xdk8LWq1RDgSPEHX1YrDhAL";
    }

    isValid() {
        return Cookies.get(this.cookieAccessToken) !== undefined;
    }

    get accessToken() {
        return Cookies.get(this.cookieAccessToken);
    }

    get refreshToken() {
        return Cookies.get(this.cookieRefreshToken);
    }

    get userId() {
        return Cookies.get(this.cookieUserId);
    }

    get refreshTokenExpirationDate() {
        return Cookies.get(this.cookieTokenExpirationDate);
    }

    get accessTokenExpirationDate() {
        return Cookies.get(this.cookieAccessTokenExpirationDate);
    }

    get fullName() {
        const token = parseJwt(this.accessToken);
        return !token ? '' : token.Name;
    }
    get firstName() {
        const fullName = this.fullName;
        return fullName.split(' ')[0];
    }
    get lastName() {
        const fullName = this.fullName;
        return fullName.split(' ').pop();
    }
    get initials() {
        const first = this.firstName;
        const last = this.lastName;
        return `${first.substring(0,1)}${last.substring(0,1)}`.toUpperCase();
    }
    get customerName() {
        const token = parseJwt(this.accessToken);
        return !token ? '' : token["CurrentCustomerName"];
    }
    get customerId() {
        const token = parseJwt(this.accessToken);
        return !token ? '' : token["CurrentCustomerId"];
    }
    get allClaims() {
        return parseJwt(this.accessToken);
    }
    get applicationRole() {
        const token = parseJwt(this.accessToken);

        if (token === undefined)
        {
            return "No Access";
        }

        return token["Enterprise"] === undefined ? "No Access" : token["Enterprise"];
    }

    hasProductSubscription(productName) {
        const cookieValue = Cookies.get(this.cookieCustomerProducts);

        if (!(cookieValue)) return false;

        const customerProducts = JSON.parse(cookieValue);

        return customerProducts.some(p => p.productName.toLowerCase() === productName.toLowerCase());
    }

    getTransferableProducts() {
        const token = parseJwt(this.accessToken);
        if (!token) return undefined;
        const allTokenKeys = Object.keys(token);
        const userProducts = allTokenKeys.filter(key => {return allTransferableProducts[key.toLowerCase()] !== undefined;});
        let idCounter = 1;
        const transferableProducts = userProducts.map(userProduct => {
            return { //ProductModel
                id: idCounter++,
                name: userProduct,
                icon: allTransferableProducts[userProduct.toLowerCase()]
            };
        });
        return transferableProducts;
    }

    setTokenInfo(accessToken, refreshToken, userId, refreshTokenExpirationMinutes, accessTokenExpirationSeconds) {
        if (refreshTokenExpirationMinutes === undefined
            || refreshTokenExpirationMinutes == null
            || refreshTokenExpirationMinutes < 0) {
            refreshTokenExpirationMinutes = 59;
        }

        const expirationDate = {expires: refreshTokenExpirationMinutes * 60 };

        Cookies.set(this.cookieAccessToken, accessToken, expirationDate);
        Cookies.set(this.cookieRefreshToken, refreshToken, expirationDate);
        Cookies.set(this.cookieUserId, userId, expirationDate);
        Cookies.set(this.cookieTokenExpirationDate, moment().add(refreshTokenExpirationMinutes, "minutes").toISOString(), expirationDate);
        Cookies.set(this.cookieAccessTokenExpirationDate, moment().add(accessTokenExpirationSeconds, "seconds").toISOString(), expirationDate);
    }

    setCustomerProducts(customerProducts) {
        const expirationDate = Cookies.get(this.cookieTokenExpirationDate);

        Cookies.set(this.cookieCustomerProducts, JSON.stringify(customerProducts), expirationDate);
    }

    logout() {
        Cookies.expire(this.cookieAccessToken);
        Cookies.expire(this.cookieRefreshToken);
        Cookies.expire(this.cookieUserId);
        Cookies.expire(this.cookieTokenExpirationDate);
        Cookies.expire(this.cookieAccessTokenExpirationDate);
    }
}

export let CurrentUser = new currentUser();
